import LoadUrlService from "@services/load-url-service";
import { initialiseComponents } from "../../core";
import Component from "../component.abstract";
import { hw } from "../helpers/paths";
import {createElementFromHTML} from "@utils/html/html.utils";

interface LoadUrlProps {
    value: string;
    src?: string;
}

const loadedUrls: Record<string, Promise<string>> = {};

/**
 * Load Url Component
 */
export default class LoadUrl extends Component {
    private service: LoadUrlService;
    private urlToLoad: string;

    constructor (
        private props: LoadUrlProps,
        element:HTMLElement
    ) {
        super(props, element);
    }

    mounted(): void {
        this.urlToLoad = this.props.src ?? this.props.value;

        if (this.urlToLoad) {
            let trimmedUrl: string;

            if (this.urlToLoad.startsWith("../")) {
                trimmedUrl = this.urlToLoad.substring(3);
            } else {
                if (this.urlToLoad.startsWith("/")) {
                    trimmedUrl = this.urlToLoad.substring(1);
                } else {
                    if (!(this.urlToLoad.startsWith("http://") || this.urlToLoad.startsWith("https://") )) {
                        trimmedUrl = this.urlToLoad;
                    }
                }
            }

            if (trimmedUrl) {
                if (trimmedUrl.startsWith("img") || trimmedUrl.startsWith("hellement")) {
                    this.urlToLoad = hw.getBaseRessourcesUrl() + "/" + trimmedUrl;
                }
            }

            // Check if this file was already loaded
            const loaded = loadedUrls[this.urlToLoad]

            if (loaded) {
                // Inject content once file is fetched
                loaded.then((data:string) => {
                    this.inject(data);
                });
            } else {
                // Load file
                loadedUrls[this.urlToLoad] = new Promise(resolve => {
                    this.service = new LoadUrlService(this.urlToLoad);
                    this.service.get((data: string) => {
                        // Set data for requests on same URL 
                        resolve(data);

                        this.inject(data);
                    });
                })
            }
        }
    }

    inject(data: string):void {
        // Create element
        const elementToInject = createElementFromHTML(data) as HTMLElement

        if (this.element.nodeName.toLowerCase() === "svg") {
            // SVG elements might have some event listeners.
            // Instead of replacing the element, which will discard all event listeners,
            // we copy the parts we want
            this.element.removeAttribute("data-load-url");

            // Copy all attributes
            for (const attribute of elementToInject.attributes) {
                this.element.setAttribute(attribute.nodeName, attribute.nodeValue);
            }

            // Replace element content
            this.element.innerHTML = elementToInject.innerHTML;

        } else {
           
                // Copy all attributes except data-load-url
                for (const attribute of this.element.attributes) {
                    if (attribute.nodeName !== "data-load-url") {
                        elementToInject.setAttribute(attribute.nodeName, attribute.nodeValue);
                    }
                }

                // Replace the whole element
                this.element.replaceWith(elementToInject);
        }

        if (!data.startsWith("<svg")) {
            initialiseComponents();
        }
    }
}